/**
 * @Author: shenyi
 * @Date:   2023-09-13 20:12:15
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-09-26 19:01:49
 */
import HttpRequest from "./axios";
import Cookies from "js-cookie";
import Qs from "qs";

const baseUrl =
  process.env.REACT_APP_ENV === "production"
    ? "https://prod-api.dbxiao.com"
    : process.env.REACT_APP_ENV === "test"
    ? "https://api-test.dbxiao.cn"
    : "";

let groupId = "";
let bayToken = "";
console.log(window.location.search);
if (window.location.search) {
  let params = Qs.parse(window.location.search.split("?")[1]);
  console.log(params);
  groupId = params.system_partition_gId
    ? String(params.system_partition_gId)
    : "";

  bayToken = params.bayToken ? String(params.bayToken) : "";
  if (bayToken && bayToken !== "") {
    const options = {
      secure: true,
      sameSite: 'None',
    };
    Cookies.set('token',bayToken,options);
  }
}
console.log(groupId);
const axios = new HttpRequest(baseUrl, groupId);
export default axios;
